import { FC } from 'react';
import { useGetUserStatus } from '@/containers/UserStatusContainer';
import { numberFormat, Text } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { useIsMasked } from '@/hooks/isMasked';
import { useFindFundAssetByFundCode } from '../../../../../../../hooks/useFindFundAsset';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';

export const AssetAmount: FC = () => {
  const { isMasked, setIsMasked, maskedSymbol } = useIsMasked('sideBarMasked');

  const { isVerified } = useGetUserStatus();

  // * Always mask for unverified user
  const shouldMask = !isVerified || isMasked;

  const fundCode = useGetFundCodeFromQuery();

  const { fundAsset } = useFindFundAssetByFundCode(fundCode, true);

  const { assetValue } = fundAsset || {};

  const formattedAssetValue =
    assetValue !== undefined ? numberFormat(assetValue) : '-';

  return (
    <div className="flex items-center justify-end gap-x-2">
      <Icon
        className="cursor-pointer text-mofidgreen-filled-primary-enabled"
        icon={!shouldMask ? 'visibility_off_outline' : 'visibility_outline'}
        size={24}
        onClick={() => setIsMasked(!isMasked)}
      />
      <div className="flex items-center gap-x-1">
        <Text
          className="text-gray-filled-primary-enabled"
          size="xl"
          weight="demibold"
        >
          {shouldMask ? maskedSymbol : formattedAssetValue}
        </Text>
        <Text
          className="text-gray-filled-tertiary-enabled"
          size="xs"
          weight="medium"
        >
          ریال
        </Text>
      </div>
    </div>
  );
};
